module.exports = {
      id: "icon-google-play-usage",
      viewBox: "0 0 12.598 13.975",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-google-play",
      toString: function () {
        return this.url;
      }
    }